<template>
  <div id="app">
    <navbar class="justify-content-between" dark position="top">
      <div class="menu-bar" v-show="formMenuBar">
        <fa
          icon="bars"
          class="text-center icon-div"
          size="2x"
          color="white"
          @click.native="handleBtnAClick"
        />
        <img src="../src/assets/img/FinalPoster/logo170x140.png" alt class="logo-img" @click="Homepage()" />
        <div class="side-text" @click="Homepage()">
          <p class="logo-th">RTAF IPTV</p>
          <p class="logo-eng">ROYAL THAI AIR FORCE</p>
        </div>
      </div>

      <div class="menu-bar2" v-show="formMenuBar2">
        <fa icon="bars" class="text-center icon-div" color="white" @click.native="handleBtnAClick" />
      </div>

      <div class="form-search">
        <input
          type="text"
          class="searchTerm form-control"
          placeholder="ค้นหาคลิปวีดีโอ"
          v-model="inputSearch"
          v-on:keyup.enter="Search()"
        />
        <btn type="submit" class="searchButton btn-search" @click="Search()">
          <i class="fa fa-search"></i>
        </btn>
      </div>

      <div class="btn-back" v-show="formSearch">
        <i class="fa fa-arrow-left" @click="ToggleSearch()"></i>
      </div>

      <div class="form-search2" v-show="formSearch">
        <input
          type="text"
          class="searchTerm2 form-control"
          placeholder="ค้นหาคลิปวีดีโอ"
          v-model="inputSearch"
          v-on:keyup.enter="Search()"
        />
        <btn type="submit" class="searchButton2 btn-search" @click="Search()">
          <i class="fa fa-search"></i>
        </btn>
      </div>

      <ul class="nav navbar-nav nav-flex-icons" v-show="!formSearch">
        <li class="search-icon">
          <a @click="ToggleSearch()">
            <i class="fa fa-search"></i>
          </a>
        </li>
        <li class="public-channel">
          <btn class="btn-public" color="blue darken-4" @click="PlayPublicChannel()">
            <div class="bg-show">
              <div class="overlay"></div>
            </div>
            <fa icon="globe" class="mr-1" />
            <span class="span-btn-public">Public Channel</span>
          </btn>
        </li>
        <li>
          <mdb-dropdown
            class="notification"
            v-if="checkUser == 'true' || checkUser && checkUser === undefined"
          >
            <mdb-dropdown-toggle class="btn-notification" slot="toggle">
              <fa icon="bell" class />
              <span class="alert-noti" v-if="!badge == '0'">{{badge}}</span>
            </mdb-dropdown-toggle>
            <mdb-dropdown-menu right class="box-notification">
              <div
                class="noti-detail"
                v-for="item in notification"
                v-bind:class="[ActiveNotification(item.active) ? 'noti-detail' : 'noti-detail2']"
              >
                <div class @click="delNotification(item.id)">
                  <fa icon="close" class="del-noti" />
                </div>
                <div class @click="playNotification(item)">
                  <div class>
                    <img :src="item.thumb" class="avatar-chat" />
                  </div>
                  <div class>
                    <p class="title-noti">{{item.name}}</p>
                    <p class="date-noti">{{item.desc}}</p>
                    <p class="date-noti2">{{item.updatedAt | formatDateTime }}</p>
                  </div>
                </div>

                <!--div class="dropdown-divider"></div-->
              </div>
              <div class v-if="!notification.length">
                <p class="title-noti">คุณยังไม่มีการแจ้งเตือน</p>
              </div>
            </mdb-dropdown-menu>
          </mdb-dropdown>
        </li>
        <li>
          <btn
            class="btn-login"
            color="blue darken-4"
            @click.native="modalLogin = true"
            v-if="checkUser == 'false' || !checkUser"
          >
            <fa icon="user-circle-o" class="mr-1" />เข้าสู่ระบบ
          </btn>
        </li>
        <!--li>
          <btn class="btn-register" color="blue darken-4" @click.native="modalRegister = true" v-if="checkUser == 'false' || !checkUser">
            <fa icon="edit" class="mr-1" /> ลงทะเบียน
          </btn>
        </li-->

        <li>
          <mdb-dropdown
            id="btn-profile"
            v-if="checkUser == 'true' || checkUser && checkUser === undefined"
          >
            <mdb-dropdown-toggle class="btn-profile" slot="toggle" ref="updatex">
              <img :src="thumbUser" alt class="avatar" />
              <span class="account">{{ShowUser}}</span>
            </mdb-dropdown-toggle>
            <mdb-dropdown-menu right>
              <mdb-dropdown-item>
                <router-link to="/profile">
                  <div>
                    <fa icon="user-circle-o" class="mr-1" />โปรไฟล์
                  </div>
                </router-link>
              </mdb-dropdown-item>
              <mdb-dropdown-item>
                <router-link to="/changepass">
                  <div>
                    <fa icon="key" class="mr-1" />เปลี่ยนรหัสผ่าน
                  </div>
                </router-link>
              </mdb-dropdown-item>
              <!--mdb-dropdown-item>
                <router-link to="/favorite"><div>รายการโปรด</div></router-link>
              </mdb-dropdown-item>
              <mdb-dropdown-item>
                <router-link to="/history"><div>ประวัติการเข้าชม</div></router-link>
              </mdb-dropdown-item-->
              <div class="dropdown-divider"></div>
              <mdb-dropdown-item>
                <div @click="Logout()">
                  <fa icon="sign-out" class="mr-1" />ออกจากระบบ
                </div>
              </mdb-dropdown-item>
            </mdb-dropdown-menu>
          </mdb-dropdown>
        </li>
      </ul>
      <!--div class="zone-user">
      </div-->

      <mdb-navbar-toggler />
    </navbar>

    <side-nav class="white-skin" :OpenedFromOutside.sync="toggleA" hidden>
      <ul>
        <li>
          <div class="menu-side" @click="CloseSide()">
            <!--i class="fa fa-bars"></i-->
            <img src="../src/assets/img/FinalPoster/logo170x140.png" alt class="logo-img" />
            <div class="sidenav-text">
              <h5 class="logo-title-side">RTAF IPTV</h5>
              <p class="logo-text-side">ROYAL THAI AIR FORCE</p>
            </div>
          </div>
        </li>
        <li>
          <ul class="collapsible">
            <li>
              <router-link
                class="collapsible-header ripple-parent"
                active
                @click.native="handleBtnAClick"
                to="/"
                @click.prevent="active === 1 ? active = 0 : active = 1"
              >
                <fa class="icon-menu" icon="home" />
                <span class="text-menu">หน้าแรก</span>
              </router-link>
            </li>
            <!--li>
            <router-link class="collapsible-header ripple-parent" active  @click.native="handleBtnAClick" to="/schedule"  @click.prevent="active === 2 ? active = 0 : active = 2">
              <fa class="icon-menu" icon="table" /> <span class="text-menu">ผังรายการ</span></router-link>
            </li-->
            <li @click="PlayPublicChannel()">
              <router-link
                class="collapsible-header ripple-parent"
                active
                @click.native="handleBtnAClick"
                to
                @click.prevent="active === 3 ? active = 0 : active = 3"
              >
                <fa class="icon-menu" icon="globe" />
                <span class="text-menu">Public Channel</span>
              </router-link>
            </li>
            <li
              v-if="checkUser == 'true' || checkUser && checkUser === undefined"
              @click="SecretCH()"
            >
              <router-link
                class="collapsible-header ripple-parent"
                active
                @click.native="handleBtnAClick"
                to
                @click.prevent="active === 4 ? active = 0 : active = 4"
              >
                <fa class="icon-menu" icon="lock" />
                <span class="text-menu">Special Channel</span>
              </router-link>
            </li>
            <li
              v-if="checkUser == 'true' || checkUser && checkUser === undefined"
              @click="SecretVideo()"
            >
              <router-link
                class="collapsible-header ripple-parent"
                active
                @click.native="handleBtnAClick"
                to
                @click.prevent="active === 4 ? active = 0 : active = 4"
              >
                <fa class="icon-menu" icon="lock" />
                <span class="text-menu">Special Video</span>
              </router-link>
            </li>
            <li v-if="checkUser == 'true' || checkUser && checkUser === undefined">
              <router-link
                class="collapsible-header ripple-parent"
                @click.native="handleBtnAClick"
                to="/favorite"
                @click.prevent="active === 5 ? active = 0 : active = 5"
              >
                <fa class="icon-menu" icon="heart" />
                <span class="text-menu">รายการโปรด</span>
              </router-link>
            </li>
            <li v-if="checkUser == 'true' || checkUser && checkUser === undefined">
              <router-link
                class="collapsible-header ripple-parent"
                @click.native="handleBtnAClick"
                to="/recommended"
                @click.prevent="active === 6 ? active = 0 : active = 6"
              >
                <fa class="icon-menu" icon="thumbs-o-up" />
                <span class="text-menu">รายการแนะนำ</span>
              </router-link>
            </li>
            <li v-if="checkUser == 'true' || checkUser && checkUser === undefined">
              <a
                class="collapsible-header ripple-parent"
                @click="wave"
                @click.prevent="active === 7 ? active = 0 : active = 7"
              >
                <fa class="icon-menu" icon="play" />
                <span class="text-menu">คลังวีดีโอ</span>
                <mdb-icon
                  icon="angle-down"
                  class="rotate-icon white-text"
                  :class="active === 7 ? 'rotated' : ''"
                />
              </a>
              <transition @before-enter="beforeEnter" @enter="enter" @before-leave="beforeLeave">
                <sub-menu v-if="active === 7" class="collapse-side-nav-item">
                  <li v-for="list in Category" @click="ViewCategory(list)">
                    <router-link
                      class="ripple-parent sub-list"
                      @click.native="wave"
                      :to="'/category/' + list.id"
                    >
                      <fa class="icon-menu sub-menu" icon="minus" />
                      <span class="text-sublist">{{list.name}}</span>
                    </router-link>
                  </li>
                </sub-menu>
              </transition>
            </li>
            <li v-if="checkUser !== 'true'">
              <a
                class="collapsible-header ripple-parent"
                @click="wave"
                @click.prevent="active === 7 ? active = 0 : active = 7"
              >
                <fa class="icon-menu" icon="play" />
                <span class="text-menu">คลังวีดีโอ</span>
                <mdb-icon
                  icon="angle-down"
                  class="rotate-icon white-text"
                  :class="active === 7 ? 'rotated' : ''"
                />
              </a>
              <transition @before-enter="beforeEnter" @enter="enter" @before-leave="beforeLeave">
                <sub-menu v-if="active === 7" class="collapse-side-nav-item">
                  <li v-for="list in Category" v-if="list.public == 'enable'" @click="ViewCategoryPublic(list)">
                    <router-link
                      class="ripple-parent sub-list"
                      @click.native="wave"
                      :to="'/category/public/' + list.id"
                    >
                      <fa class="icon-menu sub-menu" icon="minus" />
                      <span class="text-sublist">{{list.name}}</span>
                    </router-link>
                  </li>
                </sub-menu>
              </transition>
            </li>
            <!--li v-for="list in Category" @click="ViewCategory(list)" v-if="checkUser == 'true' || checkUser && checkUser === undefined">
            <router-link class="collapsible-header ripple-parent" @click.native="handleBtnAClick" to="" >
              <fa class="icon-menu" icon="play" /> <span class="text-menu">{{list.name}}</span></router-link>
            </li-->
            <li v-if="checkUser == 'true' || checkUser && checkUser === undefined">
              <router-link
                class="collapsible-header ripple-parent"
                @click.native="handleBtnAClick"
                to="/watchlater"
                @click.prevent="active === 8 ? active = 0 : active = 8"
              >
                <fa class="icon-menu" icon="clock-o" />
                <span class="text-menu">ดูย้อนหลัง</span>
              </router-link>
            </li>
            <li v-if="checkUser == 'true' || checkUser && checkUser === undefined">
              <router-link
                class="collapsible-header ripple-parent"
                @click.native="handleBtnAClick"
                to="/history"
                @click.prevent="active === 9 ? active = 0 : active = 9"
              >
                <fa class="icon-menu" icon="history" />
                <span class="text-menu">ประวัติการเข้าชม</span>
              </router-link>
            </li>
            <li>
              <router-link
                class="collapsible-header ripple-parent"
                @click.native="handleBtnAClick"
                to="/contactus"
                @click.prevent="active === 10 ? active = 0 : active = 10"
              >
                <fa class="icon-menu" icon="phone" />
                <span class="text-menu">ติดต่อเรา</span>
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
      <div class="text-center version">
        <p class="text-version">Version 1.2.0</p>
      </div>
    </side-nav>
    <main>
      <router-view></router-view>
    </main>
    <!--Footer color="special-color-dark"-->
    <Footer class="footer-color">
      <div class="footer-app">
        <div class="text-center header-app">
          <h3>Get Started with the mobile app !</h3>
        </div>
        <div class="text-center">
          <img src="../src/assets/img/FinalPoster/playstore105x36.png" class="logo-android" @click="downloadAndroid()" />
          <img
            src="../src/assets/img/FinalPoster/appstore105x36.png"
            @click="downloadIOS()"
            class="download-app"
          />
        </div>
      </div>

      <!--mdb-card class="card-app">
      <mdb-card-body>
      <div class="text-center header-app">
        <h3>Get Started with the mobile app !</h3>
      </div>
      <div class="text-center">
        <img src="../src/assets/img/android.png" class="logo-android">
        <img src="../src/assets/img/app_store_badge.png" class="download-app">
      </div>
    </mdb-card-body>
      </mdb-card-->
      <container>
        <mdb-row>
          <mdb-col md="12">
            <div class="logo-footer">
              <img src="../src/assets/img/FinalPoster/logo170x140.png" alt class="footer-logo" />
              <div class="nav-text">
                <h5 class="text-title">RTAF IPTV</h5>
                <p class="text">ROYAL THAI AIR FORCE</p>
              </div>
            </div>

            <div class="contact-footer">
              <p class="text text-center address">กรมสื่อสารอิเล็กทรอนิกส์ทหารอากาศ</p>
              <p class="text text-center address">171 แขวงสีกัน เขตดอนเมือง กทม 10210</p>
              <span class="phone-footer">
                <i class="fa fa-phone icon-footer"></i> 02-534-8019
              </span>
            </div>

            <div class="social text-center">
              <div class>
                <span @click="facebook()">
                  <i class="fa fa-facebook"></i>
                </span>
                <!--span><i class="fa fa-google"></i></span>
                <span><i class="fa fa-youtube"></i></span-->
              </div>
            </div>
          </mdb-col>
        </mdb-row>
      </container>
      <p class="footer-copyright mb-0 py-3 text-center">
        &copy; {{new Date().getFullYear()}} Copyright:
        <a
          href="http://www.rtaf.mi.th"
        >Royal Thai Air Force</a> | 

        <a
          href="/#/privacy-policy"
        >Privacy Policy</a>

      </p>
    </Footer>

    <!-- Modal login -->
    <modal centered v-if="modalLogin" @close="modalLogin = false" ref="modalApp">
      <fa class="close-modal" color="white" icon="close" @click.native="modalLogin = false" />
      <modal-body class="body-login">
        <div class="text-center">
          <img src="../src/assets/img/FinalPoster/logo170x140.png" class="img-logo-login" />
          <h3 class="header-login">กองทัพอากาศ</h3>
        </div>
        <p class="alert-text">{{Alertlogin}}{{AlertForget}}</p>
        <div class="input-login">
          <div class="form-group">
            <input
              type="text"
              v-model="inputEmail"
              id="email"
              class="form-control form-control-md input-edit"
              placeholder="อีเมล"
            />
          </div>
          <div class="form-group">
            <input
              :type="type"
              v-on:keyup.enter="Login()"
              v-model="inputPassword"
              id="password"
              class="form-control form-control-md input-edit"
              placeholder="รหัสผ่าน"
            />
            <i
              class="fa fa-eye btn-show-pass"
              @click="ShowPassword()"
              :class="[ btnShowpass ? 'fa fa-eye' : 'fa fa-eye-slash' ]"
            ></i>
          </div>
          <div class>
            <div class="custom-control custom-checkbox">
              <input
                @click="RememberMe()"
                type="checkbox"
                class="custom-control-input"
                id="defaultChecked2"
                v-model="inputRemember"
              />
              <label class="custom-control-label" for="defaultChecked2">จดจำฉัน</label>
            </div>
            <p class="forget-pass" @click="ClickForgetPass()">
              <a>ลืมรหัสผ่าน</a>
            </p>
          </div>
        </div>
        <div class="login-btn text-center">
          <btn class="btn-confirm-login btn-rounded btn-block" @click="Login()">เข้าสู่ระบบ</btn>
        </div>
      </modal-body>
    </modal>

    <!-- Modal register -->
    <!--modal centered v-if="modalRegister" @close="modalRegister = false" >

        <modal-body>
          <fa class="close-modal" color="danger" icon="close" @click.native="modalRegister = false"/>
          <div class="img-banner" v-for="item in ThumbLogin">
            <figure class="sixteen-nine-img">
              <img :src="item.thumb" >
            </figure>
          </div>

          <div class="body-register">

          </div>

            <div class="from-register">
              <h3 class="header-register">ลงทะเบียน</h3>
              <div class="input-register">
                <div class="avatar-upload-register">
                  <div class="avatar-edit-register">
                    <input type='file' id="imageUpload" accept="image/*" name="file" @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length">
                    <label for="imageUpload"></label>
                  </div>
                  <div class="avatar-preview-register">
                    <img id="imagePreview" src="..\src\assets\img\avatar_107646.png">

                  </div>
                </div>

                <div class="textbox">
                  <input v-validate="'required|email'" v-model="EmailRegister" name="email" type="text" placeholder="อีเมล์" class="form-control" :class="{ 'is-invalid': errors.has('email') }">
                  <span class="help is-danger">{{ errors.first('email') }}</span>
                  <span class="help is-danger">{{alertEmailFalse}}</span>
                  <span class="help is-success">{{alertEmailTrue}}</span>
                </div>

                <mdb-row>
                 <mdb-col>
                <div class="textbox">
                  <input v-validate="'required'" v-model="FirstnameRegister" name="name" type="text" placeholder="ชื่อ" class="form-control" :class="{ 'is-invalid': errors.has('name') }">
                  <span class="help is-danger">{{ errors.first('name') }}</span>
                </div>
              </mdb-col>

              <mdb-col>
                <div class="textbox">
                  <input v-validate="'required'" v-model="LastnameRegister" name="lastname" type="text" placeholder="นามสกุล" class="form-control" :class="{ 'is-invalid': errors.has('lastname') }">
                  <span class="help is-danger">{{ errors.first('lastname') }}</span>
                </div>
              </mdb-col>
                </mdb-row>

                <div class="textbox">
                  <input v-validate="{ required: true, min: 6 }" v-model="PasswordRegister" name="Password" type="password" placeholder="รหัสผ่าน" class="form-control" ref="password" :class="{ 'is-invalid': errors.has('Password') }">
                  <span class="help is-danger">{{ errors.first('Password') }}</span>
                </div>

                <div class="textbox">
                  <input v-validate="'required|confirmed:password'" name="Confirm Password" type="password" placeholder="ยืนยันรหัสผ่าน" class="form-control" data-vv-as="password" :class="{ 'is-invalid': errors.has('Confirm Password') }">
                  <span class="help is-danger">{{ errors.first('Confirm Password') }}</span>
                </div>

              </div>

              <div class="register-Btn text-center">
                <btn class="btn-confirm-register" @click="Register()" color="primary" :disabled="errors.any() || EmailRegister == '' || FirstnameRegister == '' || LastnameRegister == '' || PasswordRegister == '' || alertEmailFalse == 'มี Email Address นี้ในระบบแล้ว' ">ลงทะเบียน</btn>
              </div>
            </div>
        </modal-body>
      </modal>
    < /Modal register-->
  </div>
</template>

<script>
import { upload } from "./file-upload";
var config = require("./config");
import axios from "axios";
const Host = config.default.app.Host;
const formData = new FormData();
import {
  mdbIcon,
  Navbar,
  mdbNavbar,
  mdbNavbarToggler,
  NavbarItem,
  NavbarNav,
  NavbarCollapse,
  mdbNavbarBrand,
  Footer,
  mdbFooter,
  SideNav,
  Btn,
  Container,
  Row,
  Fa,
  SubMenu,
  waves,
  Modal,
  ModalHeader,
  ModalTitle,
  ModalBody,
  ModalFooter,
  mdbDropdown,
  mdbDropdownToggle,
  mdbDropdownMenu,
  mdbDropdownItem,
  mdbCard,
  mdbCardImage,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbBtn,
  mdbRow,
  mdbCol,
  mdbPopover
} from "mdbvue";
import { Validator } from "vee-validate";

const dict = {
  custom: {
    email: {
      required: "กรุณากรอก Email address"
    }
  }
};

Validator.localize("th", dict);

export default {
  name: "app",
  components: {
    mdbIcon,
    mdbPopover,
    Navbar,
    mdbNavbar,
    mdbNavbarToggler,
    NavbarItem,
    NavbarNav,
    NavbarCollapse,
    mdbNavbarBrand,
    Footer,
    SideNav,
    Btn,
    Container,
    Row,
    Fa,
    SubMenu,
    waves,
    Modal,
    mdbFooter,
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalFooter,
    config,
    mdbDropdown,
    mdbDropdownToggle,
    mdbDropdownMenu,
    mdbDropdownItem,
    mdbCard,
    mdbCardImage,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbBtn,
    mdbRow,
    mdbCol
  },
  data() {
    return {
      modalInformation: true,
      typelogin: "",
      publicChannel: null,
      btnShowpass: true,
      type: "password",
      inputRemember: null,
      ThumbLogin: null,
      alertEmailFalse: "",
      alertEmailTrue: "",
      defaultThumb: "1547105732.png",
      formUser: true,
      formMenuBar2: true,
      formMenuBar: true,
      formSearch: false,
      modalLogin: false,
      modalRegister: false,
      modalSecret: false,
      toggleA: false,
      toggle: false,
      active: 0,
      elHeight: 0,
      inputEmail: "",
      inputPassword: "",
      PasswordRegister: "",
      EmailRegister: "",
      FirstnameRegister: "",
      LastnameRegister: "",
      ShowUser: "",
      Alertlogin: "",
      AlertForget: "",
      inputSearch: null,
      checkUser: null,
      thumbUser: "",
      linkTo: "/contactus",
      Category: [],
      badge: "",
      notification: "",
      window: {
        width: 0,
        height: 0
      }
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  updated() {
    this.CheckEmail();
    //this.feedNotification();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    //this.ToggleLogin();
    this.PublicChannel();
    this.CategoryList();
    this.AccountDesc();
    this.checkUser = localStorage.auth;
    this.ShowUser = localStorage.firstname;
    this.BannerLogin();
    this.Session();
    this.feedNotification();
    this.typelogin = localStorage.typefront;

    // Remember Me
    if (localStorage.remember) {
      this.inputRemember = localStorage.remember;
      this.inputEmail = localStorage.loginemail;
      this.inputPassword = localStorage.loginpassword;
    }
  },
  methods: {
    facebook() {
      window.open("https://www.facebook.com/RTAFpage/");
    },
    downloadAndroid() {
      window.open(
        "https://play.google.com/store/apps/details?id=th.mi.rtaf.app"
      );
    },
    downloadIOS() {
      window.open("https://apps.apple.com/th/app/rtaf-live/id1485253509?l=th");
    },
    delNotification(data) {
      let APIgetdelNotification = Host + "/api/v1/notification/delete";
      axios
        .post(APIgetdelNotification, {
          email: localStorage.emailfront,
          id: data
        })
        .then(response => {
          this.feedNotification();
        });
    },
    ActiveNotification(active) {
      if (active === "true") {
        return true;
      }
      return false;
    },
    playNotification(data) {
      let APIgetChangeActiveNotification =
        Host + "/api/v1/notification/change/active";
      axios
        .post(APIgetChangeActiveNotification, {
          id: data.id,
          email: localStorage.emailfront
        })
        .then(response => {
          //console.log(response);
        });
      document.location.assign("/#/live/" + data.channel);
      location.reload();
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    feedNotification() {
      let APIgetNotification = Host + "/api/v1/notification";
      axios
        .post(APIgetNotification, {
          email: localStorage.emailfront
        })
        .then(response => {
          this.badge = response.data.badge;
          this.notification = response.data.result;
        });
    },
    Session() {
      let APIgetSession = Host + "/api/v1/member/session";
      axios
        .post(APIgetSession, {
          token: localStorage.token
        })
        .then(response => {
          if (response.data.code !== "200") {
            localStorage.emailfront = "";
            localStorage.token = "";
            localStorage.auth = "false";
          }
        });
    },
    Homepage() {
      document.location.assign("/#/");
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    SecretVideo() {
      let APISecretVideo = Host + '/api/v1/video/secret';
      axios.post(APISecretVideo , {
        email: localStorage.emailfront,
        type: 'secret'
      }).then(res => {
        document.location.assign("/#/specialVOD/" + res.data.result[0].id);
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        location.reload();
      });
      
    },
    SecretCH() {
      document.location.assign("/#/pincode");
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      location.reload();
      localStorage.idSecret = "";
      localStorage.pincode = "";
    },
    PlayPublicChannel() {
      document.location.assign("/#/public/" + this.publicChannel.id);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    PublicChannel() {
      let APIgetPublicChannel = Host + "/api/v1/channel/public";
      axios.get(APIgetPublicChannel).then(response => {
        this.publicChannel = response.data.result[0];
      });
    },
    ShowPassword() {
      if (this.type === "password") {
        this.type = "text";
        this.btnShowpass = !this.btnShowpass;
      } else {
        this.type = "password";
        this.btnShowpass = !this.btnShowpass;
      }
    },
    ClickForgetPass() {
      var self = this;
      this.AlertForget = "กรุณาติดต่อผู้ดูแลระบบ";
      setTimeout(function() {
        self.AlertForget = "";
      }, 3000);
    },
    ClickRegister() {
      var self = this;
      this.modalLogin = false;
      setTimeout(function() {
        self.modalRegister = true;
      }, 500);
    },
    RememberMe() {
      if (this.inputRemember) {
        localStorage.removeItem("remember");
        localStorage.removeItem("loginemail");
        localStorage.removeItem("loginpassword");
      } else {
        localStorage.setItem("remember", true);
        localStorage.setItem("loginemail", this.inputEmail);
        localStorage.setItem("loginpassword", this.inputPassword);
      }
    },
    ToggleLogin() {
      if (localStorage.auth == "false") {
        //this.modalLogin = true;
        document.location.assign("/#/");
      }
    },
    BannerLogin() {
      let APIgetBannerLogin = Host + "/api/v1/banner";
      axios
        .post(APIgetBannerLogin, {
          position: "login"
        })
        .then(response => {
          this.ThumbLogin = response.data.result;
        });
    },
    CheckEmail() {
      let APIgetCheckEmail = Host + "/api/v1/member/check/email";
      if (this.EmailRegister.length >= 12) {
        axios
          .post(APIgetCheckEmail, {
            email: this.EmailRegister
          })
          .then(response => {
            if (response.data.status === "already exists") {
              this.alertEmailFalse = "มี Email Address นี้ในระบบแล้ว";
              this.alertEmailTrue = "";
            } else {
              this.alertEmailTrue = "สามารถใช้ Email Address นี้ได้";
              this.alertEmailFalse = "";
            }
          });
      }
    },
    ViewCategory(data) {
      this.toggleA = false;
      this.$router.push("/category/" + data.id);
      //document.location.assign('/#/category/' + data.id);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    ViewCategoryPublic(data) {
      this.toggleA = false;
      this.$router.push("/category/public/" + data.id);
      //document.location.assign('/#/category/' + data.id);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    CategoryList() {
      let APIgetCategoryList = Host + "/api/v1/category";
      axios.get(APIgetCategoryList).then(response => {
        this.Category = response.data.result;
      });
    },
    handleResize() {
      this.window.width = window.innerWidth;
      if (this.window.width >= "730") {
        this.formUser = true;
        this.formMenuBar = true;
        this.formMenuBar2 = true;
        this.formSearch = false;
      }
    },
    ToggleSearch() {
      this.formUser = !this.formUser;
      this.formMenuBar = !this.formMenuBar;
      this.formMenuBar2 = !this.formMenuBar2;
      this.formSearch = !this.formSearch;
    },
    filesChange(fieldName, fileList) {
      if (!fileList.length) return;

      var reader = new FileReader();
      reader.onload = function() {
        var dataURL = reader.result;
        var output = document.getElementById("imagePreview");
        output.src = dataURL;
      };
      reader.readAsDataURL(fileList[0]);

      var datetimestamp = Math.floor(new Date().getTime() / 1000.0);
      this.fileImage =
        datetimestamp +
        "." +
        fileList[0].name.split(".")[fileList[0].name.split(".").length - 1];

      Array.from(Array(fileList.length).keys()).map(x => {
        formData.append("file", fileList[0], this.fileImage);
      });
    },
    Save(formData) {
      upload(formData).then(x => {
        formData.delete("file");
      });
    },
    Search() {
      let notfound = "undefined";
      let space = " ";
      if (this.inputSearch === null || this.inputSearch === space) {
        document.location.assign("/#/search/" + notfound);
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      } else {
        document.location.assign("/#/search/" + this.inputSearch);
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      }
    },
    CloseSide() {
      this.toggleA = false;
      document.location.assign("/#/");
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      //location.reload();
    },
    Login() {
      let APIgetLogin = Host + "/api/v1/member/login";
      axios
        .post(APIgetLogin, {
          email: this.inputEmail,
          password: this.inputPassword
        })
        .then(response => {
          if (response.data.code == "200") {
            localStorage.typefront = response.data.type;
            localStorage.auth = "true";
            localStorage.emailfront = this.inputEmail;
            localStorage.token = response.data.token;
            location.reload();
          } else {
            var self = this;
            this.Alertlogin = "ชื่อผู้ใช้งานหรือรหัสผ่านไม่ถูกต้อง";
            setTimeout(function() {
              self.Alertlogin = "";
            }, 2000);
          }
        });
    },
    Register() {
      let APIgetRegister = Host + "/api/v1/member/register";
      if (!this.fileImage || this.fileImage == "") {
        this.fileImage = "default.png";
      }
      axios
        .post(APIgetRegister, {
          password: this.PasswordRegister,
          email: this.EmailRegister,
          firstname: this.FirstnameRegister,
          lastname: this.LastnameRegister,
          thumb: this.fileImage
        })
        .then(response => {
          if (response.data.code == "200") {
            this.Save(formData);
            this.success();
            this.modalRegister = !this.modalRegister;
          }
        });
    },
    Logout() {
      let APIgetLogout = Host + "/api/v1/member/logout";
      axios
        .post(APIgetLogout, {
          email: localStorage.emailfront
        })
        .then(response => {
          if (response.data.code == "200") {
            localStorage.typefront = "";
            localStorage.emailfront = "";
            localStorage.token = "";
            localStorage.auth = "false";
            location.reload();
          }
        });
    },
    AccountDesc() {
      let APIgetAccountDesc = Host + "/api/v1/member/account";
      axios
        .post(APIgetAccountDesc, {
          email: localStorage.emailfront
        })
        .then(response => {
          this.thumbUser = response.data.result.thumb;
          console.log(this.thumbUser);
          
          if (this.typelogin === "local") {
            this.ShowUser = response.data.result.firstname;
          } else {
            this.ShowUser = localStorage.emailfront;
          }
        });
    },
    handleBtnAClick() {
      this.toggleA = !this.toggleA;
    },
    beforeEnter(el) {
      this.elHeight = el.scrollHeight;
    },
    enter(el) {
      el.style.height = this.elHeight + "px";
    },
    beforeLeave(el) {
      el.style.height = 0;
    },
    success() {
      this.$alert.success({
        message: "สมัครสมาชิกเรียบร้อยแล้ว",
        position: "top center",
        timeOut: 3000
      });
    }
  },
  mixins: [waves]
};
</script>

<style>
.collapsible {
  margin-top: 1rem;
}

.collapsible-header {
  position: relative;
}

.collapse-item {
  overflow: hidden;
  /* height: 0; */
  padding: 0;
  transition: height 0.3s;
}

.collapse-item a {
  padding-left: 47px;
  line-height: 36px;
  /*background-color: rgba(0, 0, 0, .15);*/
}

.fa-angle-down {
  float: right;
}

.icon-div .fa {
  cursor: pointer;
}

.rotated {
  transform: rotate(180deg);
}

.flyout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  justify-content: space-between;
}

.active {
  background-color: rgba(255, 255, 255, 0.1);
}

.icon-div .fa {
  cursor: pointer;
}
</style>
